<template>
    <div class="w-full mt-4 mb-4" v-if="!existingImageMode">
        <maz-dropzone
            ref="mazDropzoneInstance"
            :options="dropzoneOptions"
            @error="handleError"
            @sending="loading = true"
            @success="handleSuccess"
            @complete="loading = false"
            @removedfile="handleFileRemoved"
        />

        <div class="formulate-input">
            <div
                class="formulate-file-upload-error"
                v-if="errors.media"
            >
                {{ errors.media[0] }}
            </div>
        </div>
    </div>
    <div class="w-full mt-4 mb-4" v-else>
        <div class="relative inline-block">
            <!-- Image Thumbnail -->
            <img :src="value" alt="Uploaded Image" class="w-32 h-32 object-cover rounded-lg shadow-lg">

            <!-- Red Circle X in the Top Right -->
            <button type='button' @click='() => {handleFileRemoved(); existingImageMode=false;}' class="absolute top-0 right-0 transform translate-x-1/2 -translate-y-1/2 bg-red-500 hover:bg-red-600 text-white w-6 h-6 rounded-full flex items-center justify-center cursor-pointer shadow-lg hover:shadow-xl transition-all duration-300">
                &times;
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['modelValue'],
        name: 'MessageFormImageDrop',
        emits: ['update:modelValue', 'preview', 'error'],
        data() {
            return {
                errors: {
                    media: null,
                },
                loading: false,
                existingImageMode: false,
                dropzoneOptions:{
                    url: route('md.create.media.submit'),
                    dictDefaultMessage: 'Click or drag to upload an image',
                    acceptedFiles: 'image/jpeg,image/jpg,image/png',
                    maxFilesize: 1, // in MB
                    maxFiles: 1,
                    autoProcessQueue: true,
                    autoRemoveOnError: true,
                    paramName: 'media', // Using media for backwards-compatibility
                    headers: {
                        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
                    }
                }
            }
        },
        computed: {
            value() {
                return this.modelValue;
            }
        },
        mounted() {
            if (this.value) {
                this.existingImageMode = true;
                this.$emit('preview', this.value);
            }
        },
        methods: {
            handleFileRemoved() {
                this.$emit('update:modelValue', null);
                this.$emit('preview', null);
                
                // Reset dropzone if it exists
                if (this.$refs.mazDropzoneInstance) {
                    this.$refs.mazDropzoneInstance.removeAllFiles();
                }
            },
            
            handleError(error) {
                // Handle dropzone errors
                console.error('Upload error:', error);
                
                // Format error message
                if (typeof error === 'object' && error.xhr && error.xhr.response) {
                    try {
                        const responseData = JSON.parse(error.xhr.response);
                        if (responseData.errors && responseData.errors.media) {
                            this.errors.media = responseData.errors.media;
                        } else {
                            this.errors.media = ['Upload failed: ' + (error.xhr.statusText || 'Unknown error')];
                        }
                    } catch (e) {
                        this.errors.media = ['Upload failed: ' + (error.xhr.statusText || 'Unknown error')];
                    }
                } else {
                    this.errors.media = Array.isArray(error) ? error : [error.toString()];
                }
                
                // Emit error to parent
                this.$emit('error', this.errors.media);
                this.$emit('update:modelValue', null);
                this.$emit('preview', null);
            },
            
            handleSuccess(response) {
                // Handle successful upload
                let data = response.response;
                let file = response.file;
                
                // Update model with URL from response
                if (data && data.url) {
                    this.$emit('update:modelValue', data.url);
                    
                    // Create preview from the file
                    this.fileToBase64(file).then(preview => {
                        this.$emit('preview', preview);
                    });
                } else {
                    console.error('Response does not contain expected URL format:', data);
                    this.handleError(['Invalid response format from server']);
                }
            },
            fileToBase64(file) {
                return new Promise((resolve, reject) => {
                    // If file is already a Dropzone file object, we need to get the actual File
                    const actualFile = file.file || file;
                    
                    let reader = new FileReader();
                    reader.onload = () => {
                        resolve(reader.result);
                    };
                    reader.onerror = reject;
                    reader.readAsDataURL(actualFile);
                });
            }
        }
    }
</script>